import { PostNeedPromptCard } from 'app/components/post-need-prompt-card';
import { PostOfferPromptCard } from 'app/components/post-offer-prompt-card';
import { Row } from 'app/design/primitives/box';
import { landingPageLargeTheme as theme } from '../large-styles';

export function LandingPostPrompts({ canPublish }: { canPublish: boolean }) {
  if (!canPublish) return null;
  return (
    <Row alignItems="center" justifyContent="center" gap="spacing.general.x4">
      <PostNeedPromptCard
        buttonText="postNeedPrompt.afterResults.button"
        newListingSource="babillard_after_search_results"
        text="postNeedPrompt.afterResults.text"
        title="postNeedPrompt.afterResults.title"
        hideStats
        v2
        style={{ marginTop: theme.spacing['spacing.general.x2'] }}
      />
      <PostOfferPromptCard
        buttonText="postOfferPrompt.first.button"
        newListingSource="babillard_after_search_results"
        text="postOfferPrompt.first.text"
        title="postOfferPrompt.first.title"
        hideStats
        v2
        style={{ marginTop: theme.spacing['spacing.general.x2'] }}
      />
    </Row>
  );
}
